import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { UpgradePlanDialog } from '../../loads/core/UpgradePlanDialog';
import { useInstantTransferPaywall } from 'shared/modules/superpay/instant-transfer/useInstantTransferPaywall';
import { InstantTransferWebViewDialog } from './InstantTransferWebViewDialog';
import { CarrierWebviewHeader } from '../CarrierWebviewHeader';

export function InstantTransferWebViewRoute() {
  const { shouldShowUpgradeDialog } = useInstantTransferPaywall();

  useDocumentTitle(shouldShowUpgradeDialog ? 'Upgrade' : 'Instant Transfer');

  if (shouldShowUpgradeDialog) {
    return (
      <CarrierWebviewHeader>
        <UpgradePlanDialog
          open={shouldShowUpgradeDialog}
          onClose={() => {
            MobileAppBridge.closeScreen();
          }}
          type="instant_transfer"
          source="Load Details"
        />
      </CarrierWebviewHeader>
    );
  }

  return <InstantTransferWebViewDialog />;
}
